import { mobileVendor, mobileModel, osName, osVersion, browserName, deviceType } from "react-device-detect";

export function getDeviceInfo() {
  let vendor = mobileVendor || "";
  let model = mobileModel || "";

  const ua = navigator.userAgent;

  if (!vendor || !model) {
    if (/OnePlus/i.test(ua)) {
      vendor = "OnePlus";
      const match = ua.match(/OnePlus[\s_-]?[A-Za-z0-9]+/i);
      if (match) model = match[0];
    }

    if (/SM-|GT-|SAMSUNG/i.test(ua)) {
      vendor = "Samsung";
      const match = ua.match(/SM-[A-Za-z0-9]+/i);
      if (match) model = match[0];
    }

    if (/Mi\s|Redmi|Xiaomi/i.test(ua)) {
      vendor = "Xiaomi/Redmi";
      const match = ua.match(/(Mi\s?[0-9]+|Redmi\s?[0-9A-Za-z]+|Xiaomi\s?[A-Za-z0-9]+)/i);
      if (match) model = match[0];
    }

    if (/RMX/i.test(ua)) {
      vendor = "Realme";
      const match = ua.match(/RMX[0-9]+/i);
      if (match) model = match[0];
    }

    if (/CPH|OPPO/i.test(ua)) {
      vendor = "Oppo";
      const match = ua.match(/(CPH[0-9]+|OPPO\s?[A-Za-z0-9]+)/i);
      if (match) model = match[0];
    }

    if (/Vivo|V\d{4}/i.test(ua)) {
      vendor = "Vivo";
      const match = ua.match(/(Vivo\s?[A-Za-z0-9]+|V[0-9]{4})/i);
      if (match) model = match[0];
    }

    if (/iPhone/i.test(ua)) {
      vendor = "Apple";
      model = "iPhone";
    }
  }

  const info = deviceType == "browser" ? `${osName} ${osVersion} ${browserName}`:`${browserName} ${osName} ${osVersion} ${model || "Unknown"}`

  return info
}
